import { graphql } from 'gql'

export const GET_CURRENT_WORKSPACE_GAM_CONNECTION = graphql(`
  query getCurrentWorkspaceGamConnection($workspaceId: ID!) {
    node(id: $workspaceId) {
      ... on Workspace {
        latestGamConnectionOrder {
          status
        }
      }
    }
  }
`)
